import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { fetchAuth, selectIsAuth } from "../../redux/slices/auth";
import Notification from "../app/pages/components/Notification";

export default function Login() {
  const dispatch = useDispatch();
  const isAuth = useSelector(selectIsAuth);

  const [show, setShow] = useState(false);
  const [text, setText] = useState("Успешно сохранено!");
  const [subText, setSubText] = useState(
    "Перенаправляем вас на главную страницу."
  );
  const [state, setState] = useState("success");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
    mode: "onChange",
  });

  const onSubmit = async (values) => {
    const data = await dispatch(fetchAuth(values));

    if (!data.payload) {
      setShow(true);
      setText("Не удалось авторизоваться!");
      setSubText("Попробуйте позже.");
      setState("error");

      setTimeout(() => {
        setShow(false);
      }, 3500);

      return;
    }

    if ("token" in data.payload) {
      localStorage.setItem("token", data.payload.token);
    }
  };

  if (isAuth) {
    return <Navigate to={"/admin/activities"} />;
  }

  return (
    <>
      <Notification
        show={show}
        setShow={setShow}
        text={text}
        subText={subText}
        state={state}
      />
      <div className="flex min-h-screen flex-1 flex-col justify-center px-6 py-12 lg:px-8 bg-kj-dark text-kj-ink">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm text-center">
          <a
            href="/"
            className="text-2xl font-extrabold tracking-widest uppercase"
          >
            KAZAKH<span className="text-kj-gold"> JAPAN</span>
          </a>
          <p className="mt-8 text-kj-gold text-xs font-extrabold tracking-[0.28em] uppercase">
            Admin
          </p>
          <h2 className="mt-3 text-3xl font-extrabold uppercase tracking-tight text-kj-ink">
            Авторизация
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-y-5 rounded-2xl border border-kj-line bg-kj-card p-6 sm:p-8"
          >
            <div>
              <label
                htmlFor="email"
                className="block text-xs font-bold uppercase tracking-[0.12em] text-kj-sub"
              >
                Электронная почта
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  {...register("email", { required: "Укажите почту" })}
                  className="block w-full rounded-md bg-kj-dark border border-kj-line py-2 px-3 text-kj-ink placeholder:text-kj-sub focus:outline-none focus:ring-2 focus:ring-kj-gold focus:border-kj-gold sm:text-sm"
                />
                <div className="mt-1 text-sm text-red-400">
                  {errors.email?.message}
                </div>
              </div>
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-xs font-bold uppercase tracking-[0.12em] text-kj-sub"
              >
                Пароль
              </label>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  {...register("password", { required: "Укажите пароль" })}
                  className="block w-full rounded-md bg-kj-dark border border-kj-line py-2 px-3 text-kj-ink placeholder:text-kj-sub focus:outline-none focus:ring-2 focus:ring-kj-gold focus:border-kj-gold sm:text-sm"
                />
                <div className="mt-1 text-sm text-red-400">
                  {errors.password?.message}
                </div>
              </div>
            </div>

            <button
              type="submit"
              className="mt-2 flex w-full justify-center rounded-sm bg-kj-gold px-3 py-2.5 text-sm font-bold uppercase tracking-[0.08em] text-kj-dark hover:bg-kj-gold/90 transition-colors"
            >
              Авторизоваться
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
